import {XauditModel} from '../xaudit.model';

export class ToothCanalConfigurationModel extends XauditModel {
  ToothCanalId: string;
  ToothId: string;
  enumToothCanalID: string;
  CanalOrder: number;

  isSaved: boolean = true;
  isDelete: boolean = false;
}
